import React from 'react'

// Components
import Header from '../components/Header'
import Card from '../components/Card'
import Footer from '../components/Footer'

const acoesPage = () =>
  <div>
    <Header name="site-header" style={{paddingBottom: '150px', marginBottom: '-130px'}}>
      <div className="container">
        <div className="grid-center">
           <div className="col-8_md-10 grid-column content center">
             <h1>
               Ações especiais do Talkative
             </h1>
             <p>A constrante mobilidade dos capitais internacionais desafia a capacidade de equalização do retorno esperado a longo prazo.</p>
           </div>
        </div>
      </div>
    </Header>
    <section className="acoes-section" style={{marginBottom: '100px'}}>
    <div className="container">

      <Card style={{marginBottom: '60px', backgroundColor: '#fff', borderRadius: '0.5rem'}}>
        <div className="col-6_xs-12" style={{
            borderTopLeftRadius: '0.5rem',
            backgroundImage: 'linear-gradient(198deg, #c0f7ef 0%, #cadcff 100%)'}}>
            {
              // need image
            }
        </div>
        <div className="col-6_xs-12">
          <div className="content">
            <h3 className="tag">Estratégias em um Novo Paradigma Globalizado</h3>
            <p>
              O que temos que ter sempre em mente é que a mobilidade dos capitais internacionais pode nos levar a considerar a reestruturação das condições inegavelmente apropriadas.
            </p>
          </div>
        </div>
        <div className="col-12">
          <h2>O aumento do diálogo entre os diferentes setores produtivos ainda não demonstrou que vai participar na mudança do sistema.</h2>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>A prática cotidiana prova que o acompanhamento das preferências de consumo oferece uma interessante oportunidade para verificação das direções preferenciais no sentido do progresso.</p>
          </div>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>Gostaria de enfatizar que o início da atividade geral de formação de atitudes deve passar por modificações independentemente dos paradigmas corporativos de desenvolvimento para o futuro.</p>
          </div>
        </div>
      </Card>

      <Card style={{marginBottom: '60px', backgroundColor: '#fff', borderRadius: '0.5rem'}}>
        <div className="col-6_xs-12">
          <div className="content">
            <h3 className="tag">O julgamento imparcial das eventualidades</h3>
            <p>
              Nunca é demais lembrar o peso e o significado destes problemas, uma vez que o consenso sobre a necessidade de qualificação representa uma abertura para a melhoria do remanejamento dos quadros funcionais.
            </p>
          </div>
        </div>
        <div className="col-6_xs-12" style={{
            borderTopRightRadius: '0.5rem',
            backgroundImage: 'linear-gradient(198deg, #c0f7ef 0%, #cadcff 100%)'}}>
            {
              // Need image
            }
        </div>
        <div className="col-12">
          <h2>A expansão dos mercados mundiais apresenta tendências no sentido de aprovar a manutenção de todos os recursos funcionais.</h2>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>A certificação de metodologias que nos auxiliam a lidar com a valorização de fatores subjetivos cumpre um papel essencial na formulação das formas de ação.</p>
          </div>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>Todas estas questões, devidamente ponderadas, levantam dúvidas sobre se a necessidade de renovação processual estende o alcance e a importância da gestão inovadora.</p>
          </div>
        </div>
      </Card>

      <Card style={{marginBottom: '60px', backgroundColor: '#fff', borderRadius: '0.5rem'}}>
        <div className="col-6_xs-12" style={{
            borderTopLeftRadius: '0.5rem',
            backgroundImage: 'linear-gradient(198deg, #c0f7ef 0%, #cadcff 100%)'}}>
            {
              // need image
            }
        </div>
        <div className="col-6_xs-12">
          <div className="content">
            <h3 className="tag">Estratégias em um Novo Paradigma Globalizado</h3>
            <p>
              O que temos que ter sempre em mente é que a mobilidade dos capitais internacionais pode nos levar a considerar a reestruturação das condições inegavelmente apropriadas.
            </p>
          </div>
        </div>
        <div className="col-12">
          <h2>O aumento do diálogo entre os diferentes setores produtivos ainda não demonstrou que vai participar na mudança do sistema.</h2>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>A prática cotidiana prova que o acompanhamento das preferências de consumo oferece uma interessante oportunidade para verificação das direções preferenciais no sentido do progresso.  </p>
          </div>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>Gostaria de enfatizar que o início da atividade geral de formação de atitudes deve passar por modificações independentemente dos paradigmas corporativos de desenvolvimento para o futuro.</p>
          </div>
        </div>
      </Card>

      <Card style={{marginBottom: '60px', backgroundColor: '#fff', borderRadius: '0.5rem'}}>
        <div className="col-6_xs-12">
          <div className="content">
            <h3 className="tag">O julgamento imparcial das eventualidades</h3>
            <p>
              Nunca é demais lembrar o peso e o significado destes problemas, uma vez que o consenso sobre a necessidade de qualificação representa uma abertura para a melhoria do remanejamento dos quadros funcionais.
            </p>
          </div>
        </div>
        <div className="col-6_xs-12" style={{
            borderTopLeftRadius: '0.5rem',
            backgroundImage: 'linear-gradient(198deg, #c0f7ef 0%, #cadcff 100%)'}}>
            {
              // need image
            }
        </div>
        <div className="col-12">
          <h2>A expansão dos mercados mundiais apresenta tendências no sentido de aprovar a manutenção de todos os recursos funcionais.</h2>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>A certificação de metodologias que nos auxiliam a lidar com a valorização de fatores subjetivos cumpre um papel essencial na formulação das formas de ação.</p>
          </div>
        </div>
        <div className="col-6">
          <div className="content padding">
            <p>Todas estas questões, devidamente ponderadas, levantam dúvidas sobre se a necessidade de renovação processual estende o alcance e a importância da gestão inovadora.</p>
          </div>
        </div>
      </Card>
    </div>
    </section>
    <Footer />
  </div>

export default acoesPage



// WEBPACK FOOTER //
// ./src/pages/acoes-talkative.js